import data from './data'
import methods from './methods'
import validations from './validations'

export default {
  data,
  methods,
  validations,
  resourcePath: '/v1/auth/login'
}



// WEBPACK FOOTER //
// ./src/app/auth/login/company/resources/index.js